// extracted by mini-css-extract-plugin
export default {"colorPicker":"GzI9Y8if2nfdfRsrQaoz"};